import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { ApiPoll, ApiPollPost, ApiUser, PollsApi } from '@tytapp/api';
import { PageComponent } from '@tytapp/common';
import { UserService } from '@tytapp/user';

@Component({
    selector: 'tyt-poll-post-editor',
    templateUrl: './poll-post-editor.component.html',
    styleUrls: ['./poll-post-editor.component.scss']
})
export class PollPostEditorComponent extends PageComponent {
    private userService = inject(UserService);
    private pollsApi = inject(PollsApi);
    private location = inject(Location);

    user: ApiUser;
    poll: ApiPoll;
    post: ApiPollPost;

    async init() {
        await this.userService.ready;
        this.user = this.userService.user;

        if (!this.user) {
            this.router.navigateByUrl('/login');
            return;
        }

        if (!this.user.staff) {
            this.router.navigateByUrl('/polls');
        }

        this.route.paramMap.subscribe(async params => {
            let pollId = params.get('pollSlug');
            let postId = params.get('postId');

            try {
                this.poll = await this.pollsApi.getPoll(pollId).toPromise();
            } catch (e) {
                this.logger.error(`Failed to fetch poll with ID ${pollId}:`);
                this.logger.error(e);
                this.redirection.go(`/`, true);
                return;
            }

            if (postId === 'new') {
                this.post = <ApiPollPost>{
                    body: '',
                    hidden: false
                };
            } else {
                this.post = this.poll.posts.find(item => item.id == +postId);

                if (!this.post) {
                    this.redirection.go('/polls', true);
                }
            }
        });
    }

    async save() {
        if (!this.post.body) {
            alert('The post body can\'t be empty');
            return;
        }

        if (!this.post.id) {
            try {
                this.post = await this.pollsApi.createPollPost(+this.poll.id, this.post).toPromise();
            } catch (e) {
                alert(`Failed to save post: ${e.message || e.error}`);
                return;
            }
            this.location.replaceState(`/polls/${this.poll.slug}/posts/${this.post.id}`);
            alert('Poll post saved successfully');
        } else {
            this.post = await this.pollsApi.updatePollPost(+this.poll.id, this.post.id, this.post).toPromise();
            alert('Poll post saved successfully');
        }
    }

    publishSuccess = false;

    async publish() {
        if (!this.post.id) {
            alert('You need to save the post before publishing');
            return;
        }

        await this.save();

        try {
            await this.pollsApi.postPollsIdPostPostIdPublish(this.poll.id, this.post.id).toPromise();
            alert('The post was published successfully');
        } catch (e) {
            this.logger.error(`Failed to publish post:`);
            this.logger.error(e);
            alert(`There was an error publishing the post: ${e.message || e.error}`);
        }
    }
}
